import Base from '@wwdev/search/js/ajaxSearch'

class AjaxSearch  extends  Base{

    init() {
        this.timeout = null;

        if (this.$scope.length > 0) {
            this.$scope.find(this.config.searchInputSelector).attr('autocomplete','off');
            this.$scope.find(this.config.searchInputSelector).on('keyup', this.handleKeyUp.bind(this));
        }
        //ditisvies
        jQuery('#search-form form').on('submit', function() {
            var obj = jQuery('input[name="q"]');
            let searchPageUrl = obj.data('search-url');
            let params = {
                q :  encodeURIComponent(jQuery(obj).val()),
                zoekin: []
            };
            if (jQuery('input[name="zoekin[]"]:checked').length >=1) {
                jQuery('input[name="zoekin[]"]:checked').each(function() {
                    params.zoekin.push(jQuery(this).val());
                })

            }
            location.href=searchPageUrl+"?" + jQuery.param(params);
            return false;
        });
        jQuery('[data-scope="filters"]').on('change', 'input[name="zoekin[]"]', function() {

            var obj = jQuery('input[name="q"]');
            let searchPageUrl = obj.data('search-url');
            let params = {
                q :  encodeURIComponent(jQuery(obj).val()),
                zoekin: []
            };
            if (jQuery('input[name="zoekin[]"]:checked').length >=1) {
                jQuery('input[name="zoekin[]"]:checked').each(function() {
                    params.zoekin.push(jQuery(this).val());
                })

            }
            location.href=searchPageUrl+"?" + jQuery.param(params);
        });
    }


    request(obj) {
        obj = jQuery('input[name="q"]');
        var $scope = this.$scope;
        let searchPageUrl = obj.data('search-url');
        var $wrapper = jQuery(this.config.wrapper);
        let params = {
            q :  encodeURIComponent(jQuery(obj).val()),
            autosuggest: true,
            zoekin: []
        };
        if (jQuery('input[name="zoekin[]"]:checked').length >=1) {
            jQuery('input[name="zoekin[]"]:checked').each(function() {
                params.zoekin.push(jQuery(this).val());
            })

        }
        this.lastRequest = jQuery.get(searchPageUrl + '?' + jQuery.param(params), (data) => {
            jQuery('body').addClass('autosuggest-active');
            $wrapper.html('');
            jQuery.each(data, function(key) {
                $wrapper.append(data[key].html);
            });
        }, 'json').always(function () {
            $scope.removeClass('loading');
        });
    }

}

export default AjaxSearch;
